import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import PanelCard from '../../performance-operations/components/PanelCard';
import { Sub, Table } from '../../performance-operations/styles';
import { formatNumber, hasValue, metaOfBreakdown, metricOf } from '../../performance-operations/config';
import { TAB_TASKS, processHealthHref } from '../../../components/performance/processHealthLinks';
import { CellLink, Dash } from '../styles';
import { MATRIX_COLUMNS, matrixTarget } from '../config';
import { stageLabel } from './SummaryKpis';

// Spec §7.2 — aşama × durum matrisi. Satırlar dönemin zorunlu aşamaları (katalog sırası; final_result ve result_ack dahil);
// sütunlar kişi tamamlama (M03, pay/payda) ve görev sayıları (Tamamlandı, Bekliyor, Gecikti, Muaf, Açılmadı). Görevsiz aşamada
// görev hücreleri "—". Hücre tıklaması → Görevler sekmesi, aşama + durum süzgeciyle (sayı = liste, §19/4). Aşamalar kısmen paralel
// olduğu için dönüşüm çubuğu yok (analiz §3); tablo kendisi erişilebilir görünümdür.
export default function StageMatrixPanel({ filters, panel, onMeta }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const history = useHistory();
  useEffect(() => { if (panel.data) onMeta?.('stageMatrix', metaOfBreakdown(panel.data)); }, [panel.data, onMeta]);
  const cells = (panel.data?.cells || []).filter((c) => c.key);
  const go = (stage, column) => history.push(processHealthHref(filters, { tab: TAB_TASKS, task: matrixTarget(stage, column) }));

  const cell = (stage, column, metric) => {
    if (column === 'people') {
      if (!hasValue(metric)) return <Dash>{t('performance.operations.kpi.noData')}</Dash>;
      return (
        <>
          <CellLink onClick={() => go(stage, column)} data-cell={`${stage}:${column}`}>{`${formatNumber(metric.value, lang)}%`}</CellLink>
          <Sub>{t('performance.operations.kpi.ratio', { num: formatNumber(metric.numerator, lang, 0), den: formatNumber(metric.denominator, lang, 0) })}</Sub>
        </>
      );
    }
    if (!metric || metric.value == null) return <Dash data-cell={`${stage}:${column}`}>—</Dash>;
    const value = Number(metric.value);
    if (value === 0) return <span data-cell={`${stage}:${column}`}>0</span>;
    return <CellLink onClick={() => go(stage, column)} data-cell={`${stage}:${column}`}>{formatNumber(value, lang, 0)}</CellLink>;
  };

  return (
    <PanelCard
      panelKey="stageMatrix" title={t('performance.processHealth.panel.stageMatrix')} span={12}
      loading={panel.loading} error={panel.error} onRetry={panel.retry} empty={cells.length === 0}
      emptyText={t('performance.operations.panel.noStages')}
    >
      <Table>
        <colgroup>
          <col style={{ width: '22%' }} />
          {MATRIX_COLUMNS.map((c) => <col key={c.key} style={{ width: c.key === 'people' ? '18%' : '12%' }} />)}
        </colgroup>
        <thead>
          <tr>
            <th>{t('performance.operations.col.stage')}</th>
            {MATRIX_COLUMNS.map((c) => <th key={c.key}>{t(`performance.processHealth.matrix.${c.key}`)}</th>)}
          </tr>
        </thead>
        <tbody>
          {cells.map((c) => (
            <tr key={c.key} data-row={c.key}>
              <td title={stageLabel(t, c.key)}>{stageLabel(t, c.key)}</td>
              {MATRIX_COLUMNS.map((col) => <td key={col.key}>{cell(c.key, col.key, metricOf(c.metrics, col.code))}</td>)}
            </tr>
          ))}
        </tbody>
      </Table>
    </PanelCard>
  );
}
